import React from 'react';

const CryptalRecordsArticle = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white p-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Cryptal Records: Breaking the Music Industry</h1>
        <div className="bg-gray-800 rounded-lg p-6">
          <p className="mb-4">The content of the Forbes article about Jeff Bezos and Project Prometheus would be displayed here.</p>
          <p className="mb-4">In a future implementation, we could extract the article content and display it directly on this page for better integration with the site's design.</p>
          <div className="border-2 border-dashed border-gray-600 rounded-lg p-8 text-center">
            <p className="text-gray-400">Article content would appear here</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CryptalRecordsArticle;